/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".callout_da567f33 .ms-Suggestions-itemButton{padding:0px;border:none}.callout_da567f33 .ms-Suggestions{width:300px}\n"}]);
export const callout = "callout_da567f33";